import lscache from 'lscache';
import { Dispatch } from 'react';
import defaultCurrencies from '~/context/CurrencyListContext/fallbackCurrencyList';

export type Currency = {
  code: string;
  name: string;
  symbol: string;
  symbol_native: string;
  countryCode: string;
};

export type CurrenciesListAction = {
  type: string;
  payload: any;
};

const CURRENCIES_CACHE_KEY = 'CURRENCIES_LIST';
const CACHE_EXPIRATION_TIME = 360;

const actionsFactory = (dispatch: Dispatch<CurrenciesListAction>) => ({
  setError: (error: string | null) => {
    dispatch({
      type: 'SET_ERROR',
      payload: { error },
    });
  },
  fetchCurrencies: async () => {
    try {
      dispatch({
        type: 'SET_LOADING',
        payload: { loading: true },
      });

      const cachedCurrencies = lscache.get(CURRENCIES_CACHE_KEY);

      if (cachedCurrencies) {
        dispatch({
          type: 'SET_CURRENCIES',
          payload: { currencies: cachedCurrencies },
        });
        dispatch({
          type: 'SET_ERROR',
          payload: { error: null },
        });
        dispatch({
          type: 'SET_LOADING',
          payload: { loading: false },
        });
        return;
      }

      const response = await fetch(`${URL_API_HOST}/api/v1/finance/currencies`);

      if (!response.ok) {
        throw new Error(`Failed to fetch currencies: ${response.statusText}`);
      }

      const currencies = await response.json();

      // Store in cache with expiration time
      lscache.set(CURRENCIES_CACHE_KEY, currencies, CACHE_EXPIRATION_TIME);

      dispatch({
        type: 'SET_CURRENCIES',
        payload: { currencies },
      });

      dispatch({
        type: 'SET_ERROR',
        payload: { error: null },
      });
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'An unknown error occurred';

      console.warn(
        `Using default currencies due to API error: ${errorMessage}`,
      );

      dispatch({
        type: 'SET_CURRENCIES',
        payload: { currencies: defaultCurrencies },
      });

      dispatch({
        type: 'SET_ERROR',
        payload: { error: errorMessage },
      });
    } finally {
      dispatch({
        type: 'SET_LOADING',
        payload: { loading: false },
      });
    }
  },
});

export default actionsFactory;
